import { render, staticRenderFns } from "./QuotationFirstStepResource.vue?vue&type=template&id=3956d945"
import script from "./QuotationFirstStepResource.vue?vue&type=script&lang=js"
export * from "./QuotationFirstStepResource.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports